import React, { Component } from 'react';
import { cn } from '@/lib/utils';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
const PHONE_NUMBER = '2066193742';
const DEFAULT_MESSAGE = "Hi, I'm on your website and I have a question";
export function LiveChat() {
  const smsLink = `sms:${PHONE_NUMBER}?body=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  const location = useLocation();
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  const bgColor = isContractors ? 'bg-[#fbbf24] hover:bg-[#f59e0b]' : 'bg-[#04A05C] hover:bg-[#17A347]';
  const textColor = isContractors ? 'text-stone-900' : 'text-white';
  return <div className="hidden md:flex fixed bottom-5 left-5 z-50 flex-col items-start" data-id="element-1139" data-mp="11kygyt42wwq6">
      <a href={smsLink} className={cn(`shadow-md flex items-center justify-center transition-all hover:scale-105 ${bgColor} ${textColor} opacity-80 hover:opacity-100`, 'bg-[#02B460]')} style={{
      width: 55,
      height: 36,
      borderRadius: 18
    }} aria-label="Text Us" data-id="element-1140" data-mp="wl3s0v3v6h7r">
        <MessageCircle className="w-4 h-4" data-id="element-1141" data-mp="2fyj9agc7t9xf" />
      </a>
    </div>;
}